import {
  MongoFaqArticleId,
  MongoFaqCollectionId,
  MongoFaqPageId,
} from "@redotech/redo-ids-mongo";
import * as z from "zod";

/**
 * Opts FAQ articles into the agent's knowledge base. Already-linked and
 * unresolvable articles are skipped rather than failing the batch.
 */
export const linkFaqKnowledge = {
  name: "linkFaqKnowledge" as const,
  input: z.object({
    links: z.array(
      z.object({
        faqPageId: MongoFaqPageId,
        faqCollectionId: MongoFaqCollectionId,
        faqArticleId: MongoFaqArticleId,
      }),
    ),
  }),
  output: z.object({ linkedCount: z.number() }),
};
